<template>
  <div id="AddArticleView" class="add-article-view">
    <b-row class="pt-3">
      <b-col class="add-article">
        <b-form id="add-article-form" @submit.prevent="save" class="add-form">
          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Page title">
                <b-form-input v-model="article.pageTitle" :disabled="isLoading" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Page description" description="Meta tag page description">
                <b-form-textarea v-model="article.pageDescription" :disabled="isLoading" :rows="2"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Keywords">
                <b-form-input v-model="article.keywords" :disabled="isLoading"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="5">
              <b-form-group label="Language">
                <multiselect id="new-article-language-select" v-model="selectedLanguage" :options="languages" label="name" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
              </b-form-group>
            </b-col>
            <b-col sm="5">
              <b-form-group label="Category">
                <multiselect id="new-article-category-select" v-model="selectedCategory" :options="categories" label="name" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group label="URL">
                <b-form-input v-model="article.url" :disabled="isLoading" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Body title">
                <b-form-input v-model="article.bodyTitle" :disabled="isLoading"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Lead text">
                <b-form-textarea v-model="article.leadText" :disabled="isLoading" :rows="4" required></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="12">
              <b-form-group label="Body description" description="Html content article">
                <b-form-textarea v-model="article.body" :disabled="isLoading" :rows="12" required></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group label="Image URL">
                <b-form-input v-model="article.imageUrl" :disabled="isLoading"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col sm="10">
              <b-form-group>
                <b-form-checkbox id="noIndexCheckbox"
                  v-model="noIndex"
                  value="true"
                  unchecked-value="false"
                  :disabled="isLoading">
                  Robots noindex
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row class="submit">
            <b-col cols="12" sm="12">
              <b-button type="submit" size="lg" variant="primary" :disabled="isLoading">Save</b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import IcgLeftNav from '@/components/layout/IcgLeftNav'
import Header from '@/components/layout/Header'
import ArticlesTab from '@/components/ArticlesTab'
export default {
  name: 'ArticlesAdd',
  components: {
    Header,
    ArticlesTab,
    IcgLeftNav
  },
  created () {
    this.selectedLanguage = this.getLanguageById('en')
    this.startNewArticle().then(() => {
      let newArticle = this.$store.state.icg.newArticle
      newArticle.locale = this.selectedLanguage.id
      this.article = Object.assign({}, newArticle)
    })
  },
  computed: {
    ...mapGetters({
      'isLoading': 'loader/isLoading',
      'categoriesByLocale': 'icg/categories',
      'getLanguageById': 'icg/getLanguageById'
    }),
    ...mapState({
      languages: state => state.icg.languages
    }),
    categories () {
      return this.categoriesByLocale(this.selectedLanguage.id)
    }
  },
  methods: {
    ...mapActions({
      'saveArticle': 'icg/saveArticle',
      'startNewArticle': 'icg/startNewArticle',
      'setArticleLocale': 'icg/setArticleLocale',
      'setArticleCategory': 'icg/setArticleCategory',
      'setNoIndex': 'icg/setNoIndex'
    }),
    save () {
      this.article.locale = this.selectedLanguage.id
      this.saveArticle().then(() => {
        this.$toastr.s('Article saved')
        this.startNewArticle().then(() => {
          let newArticle = this.$store.state.icg.newArticle
          this.article = Object.assign({}, newArticle)
          this.$router.push({name: 'articles'})
        })
      }).catch((error) => {
        this.$toastr.e(error)
      })
    }
  },
  watch: {
    article: {
      handler (newValue) {
        this.$store.dispatch('icg/setArticle', newValue)
      },
      deep: true
    },
    noIndex: {
      handler (newValue) {
        let no = newValue === 'true'
        this.article.noIndex = no
        this.setNoIndex(no)
      }
    },
    selectedCategory: {
      handler (newValue) {
        this.article.category = newValue.id
        this.setArticleCategory(newValue.id)
      },
      deep: true
    },
    selectedLanguage: {
      handler (newValue) {
        this.article.locale = newValue.id
        this.setArticleLocale(newValue.id)
      },
      deep: true
    }
  },
  data () {
    return {
      article: {},
      selectedCategory: {},
      selectedLanguage: {},
      noIndex: 'false'
    }
  }
}
</script>

<style lang="scss" scoped>

.has-error {
  color: #ff0000;
  input {
    border-color: #ff0000;
  }
}

.add-form {
  max-width: 750px;
}
.submit{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/icg/ArticleAdd.vue